import { Flexbox, Button, Text, color } from '@morressier/ts';
import { useState } from 'react';
import styled from 'styled-components';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { TYPES } from './content';

const Container = styled.div`
  padding: 1.75rem 2rem;
  border: 1px solid ${color('lightGrey')};
  border-radius: 3px;
  max-width: 62.5rem;
  margin-bottom: 1.25rem;
`;

const QuestionText = styled(Text).attrs(props => ({
  size: 'body1_new',
  fontWeight: 'bold',
  ...props,
}))``;

const AnswerContainer = styled.div`
  margin-top: 2.75rem;
`;

const AnswerText = styled(Text).attrs(props => ({ size: 'body1_new', ...props }))`
  margin-bottom: 1.5rem;
  :last-child {
    margin-bottom: 0;
  }
`;

const AnswerList = styled.ul`
  list-style: disc;
  margin-left: 1.25rem;
`;

const AnswerListItem = styled(Text).attrs(props => ({ as: 'li', size: 'body1_new', ...props }))`
  color: ${color('secondaryBrand')};
`;

interface Props {
  key: number;
  question: string;
  answer: { type: TYPES; content: string | string[] }[];
}

const getContent = (type, content) => {
  switch (type) {
    case TYPES.TEXT:
      return <AnswerText>{content}</AnswerText>;
    case TYPES.LIST:
      return (
        <AnswerList>
          {content?.map(item => (
            <AnswerListItem key={item}>{item}</AnswerListItem>
          ))}
        </AnswerList>
      );
    default:
      return null;
  }
};

const FaqItem = ({ key, question, answer }: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <Container key={key}>
      <Flexbox justifyContent="space-between" alignItems="center">
        <QuestionText>{question}</QuestionText>
        <Button
          iconLeft={open ? <FaChevronUp /> : <FaChevronDown />}
          onClick={() => setOpen(!open)}
        >
          View Answer
        </Button>
      </Flexbox>
      {open && (
        <AnswerContainer>
          {answer.map(section => getContent(section.type, section.content))}
        </AnswerContainer>
      )}
    </Container>
  );
};

export default FaqItem;
